import { useNavigate } from "react-router-dom";
import Recorder from "../../QuestionPage/recorder";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import React, { useState, useEffect, useRef } from "react";

// Fetching Data from the API]

// End

// Page Html
export default function ReTellMockPage(props) {
  // End
  const navigate = useNavigate();
  const { question, onInputChange,questionNumber } = props;
  const [text, setText] = useState("");

  const handleButtonClick = () => {
    navigate("/");
  };

  const mockData = question;
  // console.log("Mock Dec:", mockData)

  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);

  // useEffect(() => {
  //   setAudioLink(question.media_link);
  //   resetAudio();
  // }, [question]);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch(question.media_link);
        const data = await res.json(); // expecting { url: "..." }
        setAudioLink(data.url);
        resetAudio(); // Call this after setting the new audio link
      } catch (err) {
        console.error("Failed to fetch signed audio URL:", err);
      }
    };
  
    if (question?.media_link) {
      fetchSignedUrl();
    }
  }, [question]);

  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };
  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };
  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
        Question {questionNumber} of 36
        </h2>
        <p className="p-2 py-6">
        You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response.        </p>

        <div className="flex">
          <div className="flex-1">
          {audioLink && <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />}
          </div>
          <div className="flex-1">
          <Recorder
              text={text}
              setText={handleTextChange}
              {...props}
              duration={20}
              className="relative ml-6 mt-5 mb-5 bg-gray-100 w-[440px] h-56 border-4"
            />             </div>
        </div>


      </div>
    </div>
  );
}
